import { useLocation } from 'react-router-dom';

const useNavigationParams = () => {
  const { pathname, hash } = useLocation();

  const pathSegments = pathname.split('/');
  const hubName = pathSegments[1];
  const pageName = pathSegments.join('') === hubName ? 'Home' : 'Documentation';

  const tabId = pathSegments[2];

  // hot fix for language selector adding extra back slash on home page
  const isHomeDocument = pathSegments.join('') === hubName;

  const documentId = isHomeDocument ? 'home' : pathSegments.length > 2 && pathSegments.slice(2).join('/');

  return { hubId: hubName, pageName, tabId, documentId, currentPath: pathname, hash };
};

export default useNavigationParams;
